import React from "react";
import { Header, Icon } from "semantic-ui-react";

const TransferenciasCuentasPropiasHeader = () => {
  return (
    <>
      <Header as="h2" color="blue">
        <Icon name="credit card" color="yellow" /> Transferencia entre mis
        propias cuentas
      </Header>
    </>
  );
};

export default TransferenciasCuentasPropiasHeader;
